const questions = [
  {
    title:
      "A Zoo in China Was Accused of Using People in Bear Costumes — But the Bears Were Real",
    isTrue: true,
    links: [
      "https://www.nytimes.com/2023/08/01/world/asia/chinese-zoo-sun-bear-costume.html",
    ],
  },
  {
    title:
      "A Startup Is Selling Lab-Grown Coffee — With No Beans or Plants Involved",
    isTrue: true,
    links: [
      "https://www.greenqueen.com.hk/beanless-coffee-startups-lab-grown-molecular-cell-based/",
    ],
  },
  {
    title: "Fashion Brands are hiring AI clones as Full-Time Models",
    isTrue: true,
    links: [
      "https://theconversation.com/fake-models-for-fast-fashion-what-ai-clones-mean-for-our-jobs-and-our-identities-254135",
    ],
  },
  {
    title:
      "A single Cargo Ship Blocked a Canal and Cost the Global Economy an Estimated $10 Billion a Day for days",
    isTrue: true,
    links: [
      "https://www.nytimes.com/2021/07/17/world/middleeast/suez-canal-stuck-ship-ever-given.html#:~:text=CAIRO%20%E2%80%94%20When%20the%20Ever%20Given,billion%20in%20trade%20a%20day.",
    ],
  },
  {
    title: "Man Receives Pig Kidney Transplant and Organ Functions Normally",
    isTrue: true,
    links: [
      "https://www.nytimes.com/2023/08/16/health/pig-kidney-transplant.html",
    ],
  },
  {
    title:
      "Apple Developing Contact Lenses That Display Augmented Reality Without a Headset",
    isTrue: false,
    links: [],
  },
  {
    title:
      "Netflix Announces AI-Generated Series finale Based on User Watch History",
    isTrue: false,
    links: [],
  },
  {
    title:
      "Germany Passes Law Making Public Spaces Wi-Fi a Legal Right for All Citizens",
    isTrue: false,
    links: [],
  },
  {
    title:
      "Microsoft’s Copilot AI Mistakenly Filed a Lawsuit Against Itself During Internal Testing",
    isTrue: false,
    links: [],
  },
  {
    title:
      "TikTok Launches Program to Let Users Sell Their Data Directly to Advertisers",
    isTrue: false,
    links: [],
  },
];

export default questions;
